import { Box, Typography, styled } from '@mui/material';

export const SelectTabContainer = styled(Box)(() => ({
  padding: '108px 0',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}));

export const IconsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '20px',

  svg: {
    height: '40px',
    width: '40px',

    path: {
      fill: theme.palette.case.neutral.n200,
    },
  },
}));

export const StubTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.case.neutral.n700,
  marginTop: '16px',
}));
